<app-data-list
    [data]="data"
    [loading]="loadingData"
    [columns]="columns"
    [rowCls]="rowCls"
    [rowUrl]="'/admin/flight-briefs/'"
    [orderBy]="orderBy"
    (updatedOrderBy)="updatedOrderBy($event)"
    (prevPage)="prevPage()"
    (nextPage)="nextPage()"
    [currentPage]="currentPage"
    [rightBtns]="
        hasAclAccess(EnumAcl.flightBriefsAdd)
            ? [
                  {
                      label: 'GENERAL.ADD',
                      icon: faPlus,
                      url: '/admin/flight-briefs/add/' + enquiryId
                  }
              ]
            : []
    "
></app-data-list>
